import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

import { projects } from "@/data";
import type { Project } from "@/data";

import ProjectGrid from "@/components/projects/ProjectGrid";
import ProjectModal from "@/components/projects/ProjectModal";

const pickRandom = (list: Project[], count: number) => {
    const copy = [...list];
    for (let i = copy.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [copy[i], copy[j]] = [copy[j], copy[i]];
    }
    return copy.slice(0, Math.min(count, copy.length));
};

const ProjectsPreview = () => {
    const navigate = useNavigate();
    const previewProjects = useMemo(() => pickRandom(projects, 3), []);
    const [selectedProject, setSelectedProject] = useState<Project | null>(null);

    return (
        <>
            <section className="py-36 bg-white">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <div className="mb-20">
            <span className="text-sm font-medium text-[#0F766E] mb-3 block">
              수행 실적
            </span>
                        <h2 className="text-5xl font-bold text-gray-900 leading-tight mb-4">
                            주요 프로젝트
                        </h2>
                        <p className="text-base text-gray-600">
                            공공·기업 프로젝트 수행 경험을 바탕으로
                            <br />
                            연구개발과 실증까지 연결되는 프로젝트를 수행합니다.
                        </p>
                    </div>

                    <div className="mb-12">
                        <ProjectGrid
                            projects={previewProjects}
                            onSelect={(project) => setSelectedProject(project)}
                        />
                    </div>

                    <div className="text-center">
                        <button
                            onClick={() => navigate("/projects")}
                            className="inline-flex items-center justify-center px-8 h-12 bg-[#0D9488] text-white rounded-full font-medium text-sm hover:bg-[#0F766E] transition-colors cursor-pointer whitespace-nowrap"
                        >
                            전체 프로젝트 보기
                        </button>
                    </div>
                </div>
            </section>

            {selectedProject && (
                <ProjectModal
                    project={selectedProject}
                    onClose={() => setSelectedProject(null)}
                />
            )}
        </>
    );
};

export default ProjectsPreview;
